import React from 'react'
import { images } from "../../../assets/assets";

export default function MoonBackground() {
  return (
    <div className="moonUI__background">
      <img src={images.starsBackground1} className="moonUI__background__img" alt="" />
      <img src={images.starsBackground2} className="moonUI__background__img" alt="" />
      <img src={images.starsBackground3} className="moonUI__background__img" alt="" />
    </div>
  )
}
